import { RequestState } from '@shared/constants/request';
import { AccountState } from '@shared/redux/state/account';

export const initialAccountState: AccountState = {
  details: null,
  isOrganisationManager: false,
  requestState: RequestState.NOT_STARTED,
};
